import { TBusinessSector, TRawNaicsCode } from '@/shared/types';

export const getNaicsCodes = async (): Promise<TRawNaicsCode[]> => {
	try {
		const response = await fetch('/data/naics.json');

		if (!response.ok) {
			throw new Error(`Failed to fetch NAICS codes: ${response.status} ${response.statusText}`);
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error('Error loading raw NAICS codes:', error);
		throw new Error('Failed to load raw NAICS codes data');
	}
};

export const getFormattedNaicsCodes = async (): Promise<TBusinessSector[]> => {
	try {
		const response = await fetch('/data/naics_formatted.json');

		if (!response.ok) {
			throw new Error(`Failed to fetch NAICS codes: ${response.status} ${response.statusText}`);
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error('Error loading formatted NAICS codes:', error);
		throw new Error('Failed to load business sectors data');
	}
};
